import AlarmsRoutes from './AlarmsRoutes';

export function AlarmsRoot() {
  return <AlarmsRoutes />;
}

export default AlarmsRoot;
